// extracted by css-extract-rspack-plugin
export default {"wrapper":"_8X8Vy","is-right":"_3YvOM","is-center":"_24Ypq","section":"_3aAJn","subtotal":"_3KM5l","mainSummary":"_1Ls4v","divider":"_1AEd8","subfields":"OQkYt"};